'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateCartElements = UpdateCartElements;
exports.UpdateCartDraw = UpdateCartDraw;
exports.updateItem = updateItem;
exports.QtyChange = QtyChange;
exports.cartPageUpdateItem = cartPageUpdateItem;
exports.cartPageUpdateQty = cartPageUpdateQty;
exports.addToCart = addToCart;
exports.cartControls = cartControls;
exports.cartEmptyTemplate = cartEmptyTemplate;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)('#discount_cart').on('click', function () {
  var discountCode = document.getElementById("discount_code").value;
  console.log('DISCOUNTVALUe:', discountCode);
  // url.searchParams.append('discount=' + discountCode + '&');
});

// Update cart Elements

function UpdateCartElements() {

  _jquery2.default.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function success(cart) {
      console.log('CARTENTERED', cart);
      var x;
      (0, _jquery2.default)('.cart-drawer-action span,.cart-count span').html('(' + cart.item_count + ')');
      var logged_in_new = sessionStorage.getItem("logged_in");
      var urlDiscountUpdate = window.location.href;
      console.log('URLDISCOUNTUpdate:', urlDiscountUpdate);
      if (urlDiscountUpdate.indexOf("product-catalogue") > -1) {
        var discountFlagUpdate = true;
      } else {
        var discountFlagUpdate = false;
      }
      console.log('DiscountFlagValueUpdate:', discountFlagUpdate);
      if (logged_in_new == 'true' && discountFlagUpdate == true) {
        var discount = document.getElementById("discount_value").value;
        console.log('DISCOUNTNEW', discount);
        var discount_first = cart.total_price * discount / 100;
        var multiple_total = document.getElementById("multiple_items_ca").value; //FOR CA
        //var multiple_total = document.getElementById("multiple_items").value;  FOR US
        console.log('MultipleToTAL1:', multiple_total);
        var multiple_total_second = document.getElementById("multiple_items_second_ca").value; //FOR CA
        //  var multiple_total_second = document.getElementById("multiple_items_second").value;  FOR US
        var discount_final = cart.total_price - discount_first;
        console.log('discountFinal:', discount_final);

        if (cart.item_count >= 43 || cart.item_count >= 20) {
          console.log('CARTITEMCOUNT:', cart.item_count);
          (0, _jquery2.default)('.js-form-discount').val('DFQ0Y0CVJYE6');
        }

        if (discount != 1) {

          console.log('UpdateCartElements(1)');
          if (multiple_total != '0' || multiple_total_second != '0') {
            console.log('UpdateCartElements(2)');
            (0, _jquery2.default)('.total').text("$" + cart.total_price * 50 / 10000);
          } else {
            console.log('UpdateCartElements(3)');
            (0, _jquery2.default)('.total').text("$" + discount_final / 100);
          }
        }
      } else {
        console.log('UpdateCartElements(4)');
        (0, _jquery2.default)('.total').text("$" + cart.total_price / 100);
      }

      console.log(cart);
    }
  });
}

// Update CartDraw
function UpdateCartDraw() {
  function get_hostname(url) {
    var m = url.match(/^http:\/\/[^/]+/);
    return m ? m[0] : null;
  }
  var hostname = get_hostname(window.location.href);
  console.log(hostname);
  _jquery2.default.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function success(cart) {
      console.log("cart list", cart);
      if (cart.item_count > 0) {
        // Build the Cart
        (0, _jquery2.default)('.cart-list').empty();
        var cart_body = "";
        _jquery2.default.each(cart.items, function (key, item) {
          console.log(item.properties);
          var pre_order = "";
          if (item.properties == null) {} else {
            var is_pre_item = item.properties["Pre Order"];
            if (is_pre_item == 'yes') {
              var pre_order = "Pre Order";
            } else {
              var pre_order = "";
            }
          }

          var itemVariant = item.variant_options,
              sizeMl;
          sizeMl = "- " + itemVariant;
          /*  if (parseInt(itemVariant) != 0 && typeof itemVariant !== 'string' ) {
              sizeMl = "- " + itemVariant + "ml";
            }
            else if (typeof itemVariant === 'string' || itemVariant instanceof String) {
              sizeMl = itemVariant;
            } else {
              sizeMl = "";
            }  */
          var flavour = item.properties['tag'];
          debugger;
          // Retrieve data
          var logged_in = sessionStorage.getItem("logged_in");
          var urlDiscount = window.location.href;
          console.log('URLDISCOUNT:', urlDiscount);
          if (urlDiscount.indexOf("product-catalogue") > -1) {
            var discountFlag = true;
          } else {
            var discountFlag = false;
          }
          console.log('DiscountFlagValue:', discountFlag);
          if (logged_in == 'true' && discountFlag == true) {
            var discount_value = document.getElementById("discount_value").value;
            console.log('ERRORDISCOUNT', discount_value);
            var multiple_items = document.getElementById("multiple_items_ca").value;
            var multiple_items_second = document.getElementById("multiple_items_second_ca").value; /* FOR CA */
            /*   var multiple_items = document.getElementById("multiple_items").value;
               var multiple_items_second = document.getElementById("multiple_items_second").value;    FOR US */

            console.log('MultipleToTAL2:', multiple_items);
            var discount_second = item.price * discount_value / 100;
            var discount_final_value = item.price - discount_second;
            console.log('DISCOUNTFINALVALUE:', discount_final_value);
            if (discount_value != 1) {
              debugger;
              console.log('UpdateCartDraw(1)');
              if (multiple_items != '0' || multiple_items_second != '0') {
                console.log('UpdateCartDraw(2)');
                var discount_new_value = item.price * 50 / 10000;
              } else {
                console.log('UpdateCartDraw(3)');
                var discount_new_value = discount_final_value / 100;
              }
            }
          } else {
            console.log('UpdateCartDraw(4)');
            var discount_new_value = item.price / 100;
          }
          console.log("flavour", flavour);
          if (item.gift_card == true) {
            var html = '<div class="grid-list-40 gift-card-bg"> <div class="grid-list-img"> <img src="' + item.image + '"> <div class="grid-list-wrap d-flex flex-column justify-content-between"> <div class="grid-list-category"> <div class="product-sub-header"> <ul class="d-flex justify-content-between list-unstyled px-0"> <li></li><li class="ml-auto"><span data-item-id="' + item.id + '" class="remove">remove</span></li></ul> </div></div><div class="grid-list-details"> <div class="product-heading"> <h1>' + item.product_title + '</h1> <div data-price-wrapper=""> <span data-product-price="">AUD $' + item.price / 100 + '</span></div></div></div></div></div></div>';
          } else {
            var html = '<div class="product-gird-main {{flavour}}">\n                <div class="product-grid-item">\n                    <div class="product-grid-item-overlay {{flavour}} ' + flavour + '">\n\n                        <form action="/cart/add" method="post" class="d-flex" enctype="multipart/form-data">\n                            <div class="product-grid-image-content">\n                                <div class="product-grid-image d-flex h-auto ">\n                                    <div class="feature-img">\n                                    <a href="' + item.url + '">\n                                      <img src="' + item.image + '">\n                                    </a>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="product-grid-detail text-center">\n                                <div class="product-grid-title">\n                                    <h1>' + item.product_title + ' </h1>\n                                    <h3>' + item.product_type + '\n                                       ' + sizeMl + '\n                                    </h3>\n                                </div>\n                                <div class="product-grid-price">\n                                    <p id="product-cost">$' + discount_new_value + ' </p>\n                                </div>\n                                <div class="pdp-size-quantity m-auto cart-size-quantity">  \n                                  <i class="fa fa-minus quantity-minus"></i>        \n                                      <input type="number"  value="' + parseInt(item.quantity) + '" min="1" type="text" class="qty_count" name="quantity" readonly data-stock-availab="' + item.quantity + '" />\n                                  <i class="fa fa-plus quantity-plus"></i>      \n                                </div>\n                                <!-----<div class="no-stock"></div>----->\n                            </div>\n                            \n                            <div class="remove-item">\n                                <p data-item-id="' + item.id + '">Remove</p>\n                            </div>\n                        </form>\n                        \n                    </div>\n                </div>\n            </div>';
          }
          cart_body += html;
        });
        (0, _jquery2.default)('.cart-drawer-list').html(cart_body);
        (0, _jquery2.default)('.cart-list').show();
        console.log("insert success");
      } else {
        (0, _jquery2.default)('.cart-drawer-list').html("Your Cart is Empty");
      }
      cartControls();
    },
    error: function error(XMLHttpRequest, textStatus) {}
  });
}

// Delete Item From Cart
function updateItem(variantId) {
  _jquery2.default.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      "quantity": 0,
      "id": parseInt(variantId)
    },
    success: function success(line_item) {
      console.log('delete Success');
      (0, _jquery2.default)(this).closest('.product-gird-main').remove().fadeIn(200);
      UpdateCartElements();
    },
    error: function error(data, textStatus) {
      console.log(data);
    }
  });
}

function QtyChange(qty, variantId, $this) {
  _jquery2.default.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      "quantity": qty,
      "id": parseInt(variantId)
    },
    success: function success(line_item) {
      if (qty == 0) {
        $this.closest('.product-gird-main').remove();
      }
      cartEmptyTemplate();
      _jquery2.default.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function success(cart) {
          var newQnty = $this.closest('.product-gird-main').find('input[type="number"]').val();
          _jquery2.default.each(cart.items, function (key, item) {
            console.log(key + "-" + item.id + "-" + item.line_price);
            if (item.id == variantId) {
              $this.closest('.product-gird-main').find('.product-grid-price').html('<p class="money" data-money="' + item.line_price / 100 + '"> $' + item.line_price / 100 + '</p>');

              if (newQnty > item.quantity) {
                $this.closest('.product-gird-main').find('input[type="number"]').val(item.quantity);
                $this.closest('.product-gird-main').find('.no-stock').children('span').remove();
                $this.closest('.product-gird-main').find('.no-stock').append('<span>Only ' + item.quantity + ' is in Stock</span>');
              }
            }
          });
          (0, _jquery2.default)('.cart-drawer-action span,.cart-count span').html('(' + cart.item_count + ')');
          var discount_item_value = document.getElementById("discount_value").value;
          var multiple_items_added = document.getElementById("multiple_items_ca").value;
          var multiple_items_added_second = document.getElementById("multiple_items_second_ca").value; /* FOR CA */
          /*  var multiple_items_added = document.getElementById("multiple_items").value;
            var multiple_items_added_second = document.getElementById("multiple_items_second").value;  FOR US */
          console.log('MultipleToTAL3:', multiple_items_added);
          var discount_third = cart.total_price * discount_value / 100;
          var discount_value_final = cart.total_price - discount_third;
          if (discount_item_value != 1) {
            if (multiple_items_added != '0' || multiple_items_added_second != '0') {

              var discount_value_new = item.price * 50 / 10000;
            } else {
              var discount_value_new = discount_value_final / 100;
            }
          } else {
            var discount_value_new = item.price / 100;
          }

          (0, _jquery2.default)('.total').text("$" + discount_value_new);
        }

      });
      UpdateCartElements();
    },
    error: function error(data, textStatus) {
      console.log(data);
    }
  });
}
function cartPageUpdateItem(delId, data) {

  _jquery2.default.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: data,
    success: function success(line_item) {
      var target_del = delId + 1;
      _jquery2.default.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: 0,
          line: target_del
        },
        success: function success(delete_data) {
          //refresh the page
          location.reload();
        }
      });
    },
    error: function error(err_message) {
      // toastr.options = {
      //   "closeButton": false,
      //   "debug": false,
      //   "newestOnTop": false,
      //   "progressBar": false,
      //   "positionClass": "toast-bottom-center",
      //   "preventDuplicates": false,
      //   "onclick": null,
      //   "showDuration": "300",
      //   "hideDuration": "1000",
      //   "timeOut": "2500",
      //   "extendedTimeOut": "1000",
      //   "showEasing": "swing",
      //   "hideEasing": "linear",
      //   "showMethod": "slideDown",
      //   "hideMethod": "slideUp"
      // }
      // toastr.info(err_message.responseJSON.description.replace("is already sold out.", "has sold out.").replace("product",""));

      // M.toast({html: data.responseJSON.description,classes:'error',completeCallback: function(){alert('Your toast was dismissed')}});
      console.log(err_message);
    }
  });
}
function cartPageUpdateQty(Qty, delId) {

  _jquery2.default.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      quantity: Qty,
      line: delId
    },
    success: function success(delete_data) {
      console.log(delete_data);
      location.reload();
      // $.ajax({
      //   type: 'POST',
      //   url: '/cart/add.js',
      //   dataType: 'json',
      //   data : data,
      //   success: function(line_item){
      //     //refresh the page

      //     location.reload();
      //   }
      // });
    }
  });
}

// Add to Cart Function
function addToCart(data, type) {
  _jquery2.default.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: data,
    success: function success(line_item) {
      console.log("line item", line_item);
      UpdateCartElements();
      UpdateCartDraw();
      console.log("after upadtes line item", line_item);
      if (type = 'collection') {
        setTimeout(function () {
          (0, _jquery2.default)(".preloader-wrap").fadeOut();
          (0, _jquery2.default)('.cart-drawer-action')[0].click();
        }, 1000);
      } else {
        setTimeout(function () {
          (0, _jquery2.default)('.cart-drawer-action')[0].click();
        }, 1000);
      }
    },
    error: function error(data, text) {
      if (type = 'collection') {
        (0, _jquery2.default)(".preloader-wrap").fadeOut();
      }
      console.log(data);
      // toastr.options = {
      //   "closeButton": false,
      //   "debug": false,
      //   "newestOnTop": false,
      //   "progressBar": false,
      //   "positionClass": "toast-bottom-center",
      //   "preventDuplicates": false,
      //   "onclick": null,
      //   "showDuration": "300",
      //   "hideDuration": "1000",
      //   "timeOut": "2500",
      //   "extendedTimeOut": "1000",
      //   "showEasing": "swing",
      //   "hideEasing": "linear",
      //   "showMethod": "slideDown",
      //   "hideMethod": "slideUp"
      // }
      // toastr.info(data.responseJSON.description.replace("is already sold out.", "has sold out.").replace("product",""));

      // M.toast({html: data.responseJSON.description,classes:'error',completeCallback: function(){alert('Your toast was dismissed')}});
    }
  });
}

function cartControls() {
  (0, _jquery2.default)('.remove-item p').click(function () {
    var var_id = (0, _jquery2.default)(this).data('item-id');
    var_id = var_id * 1;
    var qty = 0;
    updateItem(var_id);
    (0, _jquery2.default)(this).closest('.product-gird-main').remove().fadeIn(200);
    // cartEmptyMessage();
    cartEmptyTemplate();
  });
}

function cartEmptyTemplate() {
  var emptyCartTemplate = '<div class="cart-empty text-uppercase h-100 d-flex justify-content-center align-items-center">Cart is Empty</div>';
  var cartItem_length = (0, _jquery2.default)('.cart-drawer-list .product-gird-main').length;
  if (!cartItem_length) {
    (0, _jquery2.default)('.cart-drawer-list').html(emptyCartTemplate);
  }
}